import React from 'react';
import PropTypes from 'prop-types';
import './FastProgressBar.scss';

const styleClass = {
  on_going: 'on-going',
  on_hold: 'on-hold',
  error: 'error',
};

function FastProgressBar({className, continuous, progress, label, width, height, fontSize}) {
  const currentProgress = continuous ? 0 : progress;

  const containerStyle = {width};
  const progressStyle = {width: `${currentProgress}%`, height};
  const textStyle = {fontSize};

  return (
    <div className={`cmon-fmlx-progressbar ${className}`}>
      <div className="fmlx-progressbar-container" style={containerStyle}>
        <div className={`${continuous ? 'indeterminate' : ''} fmlx-progressbar-progress`} style={progressStyle}>
          <p className="fmlx-progressbar-text" style={textStyle}>
            {label}
          </p>
        </div>
      </div>
    </div>
  );
}

FastProgressBar.styles = styleClass;

FastProgressBar.propTypes = {
  className: PropTypes.oneOf([styleClass.on_going, styleClass.on_hold, styleClass.error]),
  progress: (props, propName) => {
    if (typeof props[propName] !== 'number') return FastProgressBar.throwError('Invalid Props: "progress" should ∈ ℝ ');
    if (props[propName] < 0 || props[propName] > 100) {
      return FastProgressBar.throwError('Invalid Props: "progress" should be between 0 and 100');
    }

    return '';
  },
  width: PropTypes.string,
  label: PropTypes.string,
  continuous: PropTypes.bool,
  height: PropTypes.string,
  fontSize: PropTypes.string,
};

FastProgressBar.defaultProps = {
  progress: 0,
  className: styleClass.on_going,
  width: '100%',
  label: '',
  fontSize: '12pt',
  height: '24pt',
  continuous: false,
};

export default FastProgressBar;
